import React from 'react';
import App from './app/App';
import {createRoot} from 'react-dom/client';

const root = createRoot(
  document.getElementById('app-root') ?? document.getElementById('app-root'),
);
root.render(<App />);
